import React from 'react';
import { SVGIcon } from '@uikit/old/Icon/Icon';
import cn from 'class-names';

import './FeeCallout.scss';

type Props = {
  children: React.ReactNode;
  type?: 'info' | 'warning';
};

function FeeCallout({ children, type = 'info' }: Props): JSX.Element {
  const icon = type === 'warning' ? 'triangleAlert' : 'infoOutline';

  return (
    <div className={cn('fee-callout', { 'fee-callout--warning': type === 'warning' })}>
      <SVGIcon icon={icon} className="fee-callout__icon" size={18} />
      <div className="fee-callout__text">{children}</div>
    </div>
  );
}

export default FeeCallout;
